import { render, staticRenderFns } from "./LessonItem.vue?vue&type=template&id=19aa383e&"
import script from "./LessonItem.vue?vue&type=script&lang=ts&"
export * from "./LessonItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports